(() => {
	// Hero Display collage animation
	const block = document.querySelector('.block-hero-display');
	if (!block) return;

	const highlights = Array.from(
		block.querySelectorAll('.block-hero-display__text')
	);
	const images = Array.from(
		block.querySelectorAll('.block-hero-display__image')
	);
	if (!highlights.length || !images.length) return;

	const parseIndex = (el) => {
		const match = Array.from(el.classList).find((cls) =>
			cls.startsWith('grid-item-')
		);
		return match ? parseInt(match.replace('grid-item-', ''), 10) : null;
	};

	// Each step: highlight text index, which image positions to highlight, and which layer to show
	const steps = [
		{
			highlight: 0,
			items: [2, 4],
			layer: {
				2: 'front',
				3: 'front',
				4: 'front',
				5: 'front',
				6: 'front',
				7: 'front',
			},
		},
		{
			highlight: 0,
			items: [2, 4],
			layer: {
				2: 'rear',
				3: 'front',
				4: 'rear',
				5: 'front',
				6: 'front',
				7: 'front',
			},
		},
		{
			highlight: 1,
			items: [3, 5],
			layer: {
				2: 'rear',
				3: 'front',
				4: 'rear',
				5: 'front',
				6: 'front',
				7: 'front',
			},
		},
		{
			highlight: 1,
			items: [3, 5],
			layer: {
				2: 'rear',
				3: 'rear',
				4: 'rear',
				5: 'rear',
				6: 'front',
				7: 'front',
			},
		},
		{
			highlight: 2,
			items: [6, 7],
			layer: {
				2: 'rear',
				3: 'rear',
				4: 'rear',
				5: 'rear',
				6: 'front',
				7: 'front',
			},
		},
		{
			highlight: 2,
			items: [6, 7],
			layer: {
				2: 'front',
				3: 'rear',
				4: 'front',
				5: 'rear',
				6: 'rear',
				7: 'rear',
			},
		},
	];

	const focusedOpacity = 0.5;
	const hiddenLayerOpacity = 0;
	const swapDelay = 400;
	const stepDuration = 2600;

	// Prep transitions
	highlights.forEach((h) => {
		h.style.transition = 'opacity 0.8s ease-in-out';
	});
	images.forEach((img) => {
		img.style.transition = 'opacity 0.8s ease-in-out';
		const innerImg = img.querySelector('img');
		if (innerImg) innerImg.style.transition = 'opacity 0.8s ease-in-out';
	});

	let currentStep = 0;

	const applyImageState = (layer, activeItems) => {
		images.forEach((img) => {
			const index = parseIndex(img);
			const desiredLayer = layer[index];

			if (!desiredLayer) {
				img.style.opacity = hiddenLayerOpacity.toString();
				return;
			}

			const matchesLayer = img.classList.contains(`grid-${desiredLayer}`);
			if (!matchesLayer) {
				img.style.opacity = hiddenLayerOpacity.toString();
				return;
			}

			const innerImg = img.querySelector('img');

			const isActiveItem = activeItems.includes(index);
			if (isActiveItem) {
				img.style.opacity = '1';
				if (innerImg) innerImg.style.opacity = '1';
			} else {
				img.style.opacity = '1';
				if (innerImg)
					innerImg.style.opacity = focusedOpacity.toString();
			}
		});
	};

	const applyHighlight = (highlightIndex) => {
		highlights.forEach((h, idx) => {
			h.style.opacity = idx === highlightIndex ? '1' : '0';
		});
	};

	const runStep = () => {
		const step = steps[currentStep];
		const nextStep = steps[(currentStep + 1) % steps.length];

		// Phase 1: Highlight current images
		applyImageState(step.layer, step.items);

		// Phase 2: After delay, swap images (change layer) and change text when new images come in
		setTimeout(() => {
			applyImageState(nextStep.layer, step.items);
			applyHighlight(nextStep.highlight);
		}, stepDuration - swapDelay);

		currentStep = (currentStep + 1) % steps.length;
	};

	// Initialize
	applyImageState(steps[0].layer, steps[0].items);
	applyHighlight(steps[0].highlight);

	// Start loop after first duration
	setTimeout(() => {
		runStep();
		setInterval(runStep, stepDuration);
	}, stepDuration);
})();
